import React from 'react';
import './blog-post.css';

import women1 from './pictures/women1.jpg';
import women2 from './pictures/women2.jpg';
import women3 from './pictures/women3.jpg';


//import reportWebVitals from './reportWebVitals';

const Women = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>International Women's Day Tabling Recap</h2>
                    <p class="site-post-meta">March 8th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>                   
                    WiC officers assemebled care packages to celebrate International Women's Day!
                    The care packages are filled with goodies that celebrate WIC members' strength and achievements.
                    Thank you everyone who stopped by our tabling! 
                    Good luck on your finals and look forward to our spring events next quarter! 
                    <br></br>
                     
                    </p>
                     <img src={women1} alt=""/>
                     <img src={women2} alt=""/>
                     <img src={women3} alt=""/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Women;

